import React from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import { formatTimestamp } from '../utils/helpers';

const HistoryTab = ({ visible, theme }) => {
  if (!visible) return null;
  
  return (
    <Box 
      sx={{ 
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        flex: 1
      }}
    >
      <Typography variant="h6" color="white" sx={{ mb: 3 }}>Conversation History</Typography>
      
      <Card
        sx={{ 
          mb: 2, 
          backgroundColor: 'rgba(35, 45, 60, 0.8)',
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <CardContent>
          <Typography variant="subtitle1" color="white" fontWeight="medium">
            Feature Request Discussion
          </Typography>
          <Typography variant="caption" color="rgba(255,255,255,0.6)" sx={{ mb: 1, display: 'block' }}>
            {formatTimestamp(new Date(Date.now() - 2 * 24 * 60 * 60 * 1000))}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <Chip 
              size="small" 
              label="Feature Request" 
              sx={{ 
                backgroundColor: 'rgba(255,215,0,0.15)',
                color: '#FFD700',
                borderRadius: '4px'
              }}
            />
            <Typography variant="caption" color="rgba(255,255,255,0.5)" sx={{ ml: 1 }}>
              5 messages
            </Typography>
          </Box>
        </CardContent>
      </Card>
      
      <Card
        sx={{ 
          mb: 2, 
          backgroundColor: 'rgba(35, 45, 60, 0.8)',
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <CardContent>
          <Typography variant="subtitle1" color="white" fontWeight="medium">
            Billing Inquiry
          </Typography>
          <Typography variant="caption" color="rgba(255,255,255,0.6)" sx={{ mb: 1, display: 'block' }}>
            {formatTimestamp(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <Chip 
              size="small" 
              label="Billing Support" 
              sx={{ 
                backgroundColor: 'rgba(80,200,120,0.15)',
                color: '#50C878',
                borderRadius: '4px'
              }}
            />
            <Typography variant="caption" color="rgba(255,255,255,0.5)" sx={{ ml: 1 }}>
              3 messages
            </Typography>
          </Box>
        </CardContent>
      </Card>
      
      <Card
        sx={{ 
          backgroundColor: 'rgba(35, 45, 60, 0.8)',
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <CardContent>
          <Typography variant="subtitle1" color="white" fontWeight="medium">
            Account Verification
          </Typography>
          <Typography variant="caption" color="rgba(255,255,255,0.6)" sx={{ mb: 1, display: 'block' }}>
            {formatTimestamp(new Date(Date.now() - 14 * 24 * 60 * 60 * 1000))}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <Chip 
              size="small" 
              label="Account Issues" 
              sx={{ 
                backgroundColor: 'rgba(74,144,226,0.15)',
                color: '#4A90E2',
                borderRadius: '4px'
              }}
            />
            <Typography variant="caption" color="rgba(255,255,255,0.5)" sx={{ ml: 1 }}>
              7 messages
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default HistoryTab;
